import { memo } from 'react'
import { useTranslation } from 'react-i18next'

import { Heading } from '../Heading'

interface FailedStateProps {
  onRestart: () => void
  isDeleting: boolean
}

const FailedState: React.FC<FailedStateProps> = memo(
  ({ onRestart, isDeleting }) => {
    const { t } = useTranslation()
    return (
      <div className="h-full flex flex-col items-center justify-center px-0 sm:px-4 pt-4 sm:pt-10 mb-auto sm:mb-0">
        <div className="h-12 w-12 rounded-full bg-red-500 text-white flex items-center justify-center mb-8 text-xl">
          <i className="fa-solid fa-close" />
        </div>
        <Heading title={t('twin.generationFailed')} />
        <button
          data-testid="failed-state-restart-btn"
          className="btn btn-secondary"
          onClick={onRestart}
          disabled={isDeleting}
        >
          <i className="fa-solid fa-rotate-right mr-2" /> {t('twin.restart')}
        </button>
      </div>
    )
  },
)

export { FailedState }
